// https://gist.github.com/amk221/1bea7a783f76413e2e47
import { htmlSafe } from '@ember/template';
import { type SafeString } from '@ember/template/-private/handlebars';
import Ember from 'ember';
const escapeExpression = (Ember as unknown as { Handlebars: { Utils: { escapeExpression: (str: string) => string } } })
  .Handlebars.Utils.escapeExpression;

/*
 * This helper escapes a value, useful for building styles
 *
 * @example
 *   <div style={{escape (concat 'color:' ugcColour)}}></div>
 *
 */
export default function escape(str: string): SafeString {
  return htmlSafe(escapeExpression(str));
}
